module.exports = __webpack_public_path__ + "static/media/bg_coaching_b.d3db9d95.jpg";